/////////////////////////////////////////
// CART DRAWER OUVERTURE ET FERMETURE //
///////////////////////////////////////
console.log("The Deployer - Cart Drawer 🚀");

const cartIcon = document.querySelector("#cart-icon-bubble");
const closeDrawerBtn = document.querySelector(".close-cart-drawer");
const drawerOverlay = document.querySelector(".cart-drawer_overlay");
const drawer = document.querySelector(".cart-drawer");
const gotoCart = document.querySelector("#cart-notification-button");
const drawerFooter = document.querySelector('.cart-drawer_footer');
const drawerUpsell = document.querySelector('.cart-drawer-upsell_wrapper');
const drawerInner = document.querySelector('.cart-drawer-inner');
const drawerInnerEmpty = document.querySelector('.cart-drawer-inner_empty');
const cartItemsList = document.querySelector("#shopify-section-cart-drawer > div > div.cart-drawer > div.cart-drawer-inner > div");

// Clic sur la notification, on le laisse au cas ou
gotoCart.addEventListener("click", (e) => {
  e.preventDefault();
  cartIcon.click();
});

cartIcon.addEventListener("click", (e) => {
  e.preventDefault();
  loadCart();
  drawerOverlay.classList.add("open");
  document.querySelector('.gradient').style.overflow = "hidden";
  drawer.classList.remove("side-cart-close");
});

closeDrawerBtn.addEventListener("click", (e) => {
  loadCart()
  closeDrawer()
});

drawerOverlay.addEventListener("click", (e) => {
  closeDrawer()
});

function closeDrawer() {
  const openClass = document.querySelectorAll(".open");
  [].forEach.call(openClass, function (el) {
    el.className = el.className.replace(/\open\b/, "");
  });
  drawer.classList.add("side-cart-close");
  document.querySelector('.gradient').style.overflow = "auto";
}

/////////////////////////////////////////
// CART DRAWER AFFICHAGE DYNAMIQUE /////
///////////////////////////////////////

function toggleSpinner(toggle) {
  var spinner = document.querySelector('.cart-drawer_loading');
  if (toggle) {
    spinner.style.display = "flex";
    drawerUpsell ? drawerUpsell.style.display = "none" : null;
    drawerFooter.style.display = "none";
    drawerInner.style.display = "none";
    drawerInnerEmpty.style.display = "none";
    return;
  }
  spinner.style.display = "none";
  if (drawerInnerEmpty.style.display == "block") {
    drawerInnerEmpty.style.display = "block";
    return;
  }
  drawerUpsell ? drawerUpsell.style.display = "block" : null;
  drawerFooter.style.display = "block";
  drawerInner.style.display = "block";
}

function loadCart() {
  toggleSpinner(true)
  fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET"
    })
    .then((response) => {
      return response.json();
    })
    .then((cartItems) => {
      rebuildCart(cartItems)
      toggleSpinner(false);
    })
    .catch((error) => {
      console.error("Error:", error);
      return;
    });
}

function changeQuantity(id, quantity) {
  toggleSpinner(true)
  let formData = {
    id: id,
    quantity: quantity,
  };
  fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      return response.json();
    })
    .then((cartItems) => {
      removeInvisibleUpsell()
      rebuildCart(cartItems)
      toggleSpinner(false);
    })
    .catch((error) => {
      console.error("Error:", error);
      return;
    });
}

function removeItem(id) {
  toggleSpinner(true);
  let formData = {
    id: `${id}`,
    quantity: "0",
  };
  fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      return response.json();
    })
    .then((cartItems) => {
      removeInvisibleUpsell()
      rebuildCart(cartItems)
      toggleSpinner(false);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function rebuildCart(cartItems) {
  if (cartItems.item_count > 0) {
    document.querySelector(".cart-drawer-cta").style.display = "none";
    document.querySelector(".cart-drawer_footer").style.display = "block";
    document.querySelector(".cart-drawer-inner_empty").style.display = "none";
    if (document.querySelector(".cart-drawer-upsell_wrapper")) {
      document.querySelector(".cart-drawer-upsell_wrapper").style.display = "block";
      document.querySelector(".cart-drawer-upsell_container").style.display = "flex";
    }
    document.querySelector(".items").style.display = "block";
    cartItemsList.innerHTML = "";
    const totalPrice = cartItems.total_price / 100;
    if(document.querySelector(".total-price")){
    document.querySelector(".total-price").innerHTML = `${totalPrice.toLocaleString("fr-FR", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    })}`;
  }

  if(document.querySelector(".cart-checkbox_upsell-wrapper") != null){
        cartItems.items.forEach(item => {
          if (item.id == document.getElementById('cart-checkbox-upsell').dataset.id) {
            document.getElementById('cart-checkbox-upsell').checked = true
          }
        });
  }
  
    var isUpsellAdded = false;
    var isUpsell2Added = false;
    cartItems.items.map((item) => {
        if(!document.querySelector("#cart-checkbox-upsell") || item.id != document.querySelector("#cart-checkbox-upsell").dataset.id){
      if (document.querySelector(".cart-drawer-upsell_title")) {
        if (item.id == document.querySelector(".cart-drawer-upsell_title").dataset.id && document.querySelector("#upsell-variant-selector") == null) {
          isUpsellAdded = true;
        }
      }
      if (document.querySelector(".cart-drawer-upsell_2_title")) {
        if (item.id == document.querySelector(".cart-drawer-upsell_2_title").dataset.id && document.querySelector("#upsell-variant-selector") == null) {
          console.log('oui');
          isUpsell2Added = true;
        } else {
          console.log('non');
        }
      }
      // item card
      const prodItem = document.createElement("div");
      prodItem.className = "item";
      prodItem.setAttribute("data-id", item.variant_id);

      // image container
      const itemImgContainer = document.createElement("div");
      itemImgContainer.className = "item-img-container";

      // product img
      const itemImg = document.createElement("img");
      itemImg.className = "item-img";
      itemImg.src = `${item.image}`;

      // content container
      const contentContainer = document.createElement("div");
      contentContainer.className = "item-content-container";

      // content container top
      const contentContainerTop = document.createElement("div");
      contentContainerTop.className = "item-content-container-top";

      // product title
      const itemTitle = document.createElement("h4");
      itemTitle.className = "item-title";
      itemTitle.innerHTML = `${item.product_title}`;

      // card remove
      const removeCard = document.createElement("button");
      removeCard.className = "item-remove";
      removeCard.setAttribute("onclick", `removeItem(${parseInt(item.variant_id)})`);
      removeCard.innerHTML =
        '<svg width="9" viewBox="0 0 10 10">' +
        '<path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#cacaca" fill-rule="nonzero">' +
        "</path>" +
        "</svg>";

      // item option 1
      const itemOption1 = document.createElement("div");
      itemOption1.className = "item-option";
      itemOption1.innerHTML = `${item.options_with_values[0].name} : ${item.options_with_values[0].value}`;

      // content container top
      const contentContainerBottom = document.createElement("div");
      contentContainerBottom.className = "content-container-bottom";

      // card quantity selector
      const quantitySelector = document.createElement("div");
      quantitySelector.className = "quantity-selector";
      quantitySelector.innerHTML = `<button class="minus" data-id="${item.variant_id}" aria-label="decrease quantity"><svg width="10" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg"><path d="M11.25 0H.75C.3 0 0 .4 0 1s.3 1 .75 1h10.5c.45 0 .75-.4.75-1s-.3-1-.75-1z" fill="#7A7A7A" fill-rule="nonzero"></path></svg></button><input class="item-quantity" readonly data-id="${item.variant_id}" type="text" value=${item.quantity}><button class="plus" data-id="${item.variant_id}" aria-label="increase quantity"><svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="#7A7A7A" fill-rule="nonzero"></path></svg></button>`;

      // card quantity selector
      const finalItemPrice = item.final_line_price / 100;
      const itemPrice = document.createElement("p");
      itemPrice.className = "item-price";
      itemPrice.innerHTML = `${finalItemPrice.toLocaleString("fr-FR", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
      })}`;

      // structure
      cartItemsList.append(prodItem);
      prodItem.append(itemImgContainer);
      itemImgContainer.append(itemImg);
      prodItem.append(contentContainer);
      contentContainer.append(contentContainerTop);
      if (item.options_with_values[0].name != "Title") contentContainer.append(itemOption1);
      // item option 2
      if (item.options_with_values[1]) {
        const itemOption2 = document.createElement("div");
        itemOption2.className = "item-option";
        itemOption2.innerHTML = `${item.options_with_values[1].name} : ${item.options_with_values[1].value}`;
        contentContainer.append(itemOption2);
      }
      contentContainerTop.append(itemTitle);
      contentContainerTop.append(removeCard);
      contentContainer.append(contentContainerBottom);
      contentContainerBottom.append(quantitySelector);
      contentContainerBottom.append(itemPrice);

      // item Quantity controllers
      const increaseQuantity = document.querySelectorAll("button.plus");
      const decreaseQuantity = document.querySelectorAll("button.minus");

      decreaseQuantity.forEach(function (button) {
        button.addEventListener("click", decrease);
      });

      function decrease(evt) {
        evt.preventDefault();
        var closest = evt.currentTarget.closest(".quantity-selector").querySelector("input");
        const id = closest.getAttribute("data-id");
        const value = parseInt(closest.value);
        closest.value = value - 1;
        evt.stopImmediatePropagation();
        changeQuantity(id, closest.value);
      }

      increaseQuantity.forEach(function (button) {
        button.addEventListener("click", increase);
      });

      function increase(evt) {
        evt.preventDefault();
        var closest = evt.currentTarget.closest(".quantity-selector").querySelector("input");
        const id = closest.getAttribute("data-id");
        const value = parseInt(closest.value);
        closest.value = value + 1;
        evt.stopImmediatePropagation();
        changeQuantity(id, closest.value);
      }
      // update the cart bubble in header	
      if (document.querySelector("#cart-icon-bubble > div > span:nth-child(1)")) {
        document.querySelector("#cart-icon-bubble > div > span:nth-child(1)").innerHTML = `${cartItems.item_count}`;
      }
    }
    });
    if (document.querySelector('.cart-drawer-upsell_container')) {
      if (document.querySelector('.cart-drawer-upsell_text') != null) document.querySelector('.cart-drawer-upsell_text').style.display = 'block';
      document.querySelector('.cart-drawer-upsell_container').style.display = 'flex';
      if (isUpsellAdded) {
        if (document.querySelector('.cart-drawer-upsell_text') != null) document.querySelector('.cart-drawer-upsell_text').style.display = 'none';
        document.querySelector('.cart-drawer-upsell_container').style.display = 'none';
      }
    }
    if (document.querySelector('.cart-drawer-upsell_container2')) {
      if (document.querySelector('.cart-drawer-upsell_text') != null) document.querySelector('.cart-drawer-upsell_text').style.display = 'block';
      document.querySelector('.cart-drawer-upsell_container2').style.display = 'flex';
      if (isUpsell2Added) {
        if (document.querySelector('.cart-drawer-upsell_text') != null) document.querySelector('.cart-drawer-upsell_text').style.display = 'none';
        document.querySelector('.cart-drawer-upsell_container2').style.display = 'none';
      }
    }
  } else {
    document.querySelector(".cart-drawer-inner_empty").style.display = "block";
    document.querySelector(".cart-drawer-cta").style.display = "flex";
    document.querySelector(".cart-drawer_footer").style.display = "none";
    document.querySelector(".items").style.display = "none";
    if (document.querySelector(".cart-drawer-upsell_wrapper")) document.querySelector(".cart-drawer-upsell_wrapper").style.display = "none";
    /* if the carte bubble exist */
    if (document.querySelector("#cart-icon-bubble > div ")) document.querySelector("#cart-icon-bubble > div").style.display = `none`;
  }
}

function removeInvisibleUpsell() {
  toggleSpinner(true);
  fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET"
  })
  .then((response) => {
    return response.json();
  })
  .then((cartItems) => {
    if (cartItems.items.length == 1) {
      cartItems.items.forEach(item => {
        if (item.id == document.getElementById('cart-checkbox-upsell').dataset.id) {
          let formData = {
            id: `${item.id}`,
            quantity: "0",
          };
          fetch(window.Shopify.routes.root + "cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            })
            .then((response) => {
              return response.json();
            })
            .then((cartItems) => {
              document.getElementById('cart-checkbox-upsell').checked = false
              rebuildCart(cartItems)
              toggleSpinner(false);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      });
    } else {
      toggleSpinner(false);
    }
  })
  .catch((error) => {
    console.error("Error:", error);
    return;
  });
}

//Faire une fonction "Toggle Empty state"